<template>
  <div style="width: 100%;">
    <h1 class="title-astral">Carta astral</h1>
    <v-row class="mb-5">
      <v-col sm="12">
        <v-btn color="primary" large class="white--text text-center" @click="dialogAdd = true">
          Crear carta astral
        </v-btn>
      </v-col>
      <v-col sm="5">
        <user-search item-text="email" search-by="searchUser" @changeUser="filterDataIdUser"></user-search>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-simple-table class="table-styled" v-if="allData.length">
          <template v-slot:default>
            <thead>
            <tr>
              <th class="text-left">Usuario</th>
              <th class="text-left">Imagen</th>
              <th class="text-left">Acciones</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="data in allData" :key="data.id">
              <td>{{ data.user.email }}</td>
              <td>
                <a @click="imgModal(data.id)">Ver carta astral</a>
              </td>
              <td class="btn-size-auto">
                <v-btn class="ma-2" color="primary" @click="editModal(data.id)">
                  Editar
                  <v-icon small right>mdi-pencil</v-icon>
                </v-btn>
                <v-btn class="ma-2" tile outlined color="primary" @click="deleteModal(data.id)">
                  Eliminar
                  <v-icon small right>mdi-delete</v-icon>
                </v-btn>
              </td>
            </tr>
            </tbody>
          </template>
        </v-simple-table>
        <p v-if="!allData.length && currentUser" class="text-center">No se han encontrado cartas para el usuario. Proceda a registrarla.</p>
      </v-col>
    </v-row>

    <template>
      <v-row justify="center">
        <v-dialog v-model="dialogAdd" persistent max-width="450px">
          <v-card>
            <v-card-title class="justify-center">
              <span class="headline title-card-add">Crear carta astral</span>
            </v-card-title>
            <v-card-text class="pb-0">
              <v-container>
                <v-row>
                  <div class="ctn-astral ctn-user-search">
                    <user-search item-text="email" search-by="searchUser"></user-search>
                  </div>
                  <div class="ctn-astral ctn-file-input">
                    <v-file-input
                        color="primary accent-4"
                        counter
                        multiple
                        placeholder="Seleccione imagen"
                        prepend-icon=""
                        append-outer-icon="mdi-paperclip"
                        outlined
                        :show-size="1000"
                        type="file"
                        id="files" ref="files"
                        v-model="files">
                      <template v-slot:selection="{ index, text }">
                        <v-chip
                            v-if="index < 2"
                            color="primary accent-4"
                            dark
                            label
                            small>
                          {{ text }}
                        </v-chip>

                        <span
                            v-else-if="index === 2"
                            class="overline grey--text text--darken-3 mx-2">
      +{{ files.length - 2 }} File(s)
    </span>
                      </template>
                    </v-file-input>
                  </div>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions class="text-center d-block pb-5 btn-size-auto">
              <v-btn color="primary" class="d-inline-block" outlined  @click="closeSaveAstral">Cancelar</v-btn>
              <v-btn color="primary" class="d-inline-block" :disabled="!files || !files[0]" @click="saveAstral">Guardar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>

    <v-dialog v-model="dialogImg" max-width="650px">

      <v-card>
        <v-col class="text-end">
          <v-icon color="gris" @click="dialogImg = false">mdi-close</v-icon>
        </v-col>
        <v-img :src="imgUrl"></v-img>
      </v-card>
    </v-dialog>

    <template>
      <v-row justify="center">
        <v-dialog v-model="dialogEdit" persistent max-width="450px">
          <v-card>
            <v-card-title class="justify-center">
              <span class="headline title-card-add">Editar carta astral</span>
            </v-card-title>
            <v-card-text class="mb-0 pb-0">
              <v-container>
                <v-row>
                  <template>
                    <div class="ctn-astral ctn-file-input">
                      <v-file-input
                        color="primary accent-4"
                        counter
                        multiple
                        placeholder="Seleccione imagen"
                        prepend-icon=""
                        append-outer-icon="mdi-paperclip"
                        outlined
                        required
                        :show-size="1000"
                        type="file"
                        id="file" ref="file"
                        v-model="file">
                      <template v-slot:selection="{ index, text }">
                        <v-chip
                            v-if="index < 2"
                            color="primary accent-4"
                            dark
                            label
                            small>
                          {{ text }}
                        </v-chip>

                        <span
                            v-else-if="index === 2"
                            class="overline grey--text text--darken-3 mx-2">
        +{{ files.length - 2 }} File(s)
      </span>
                      </template>
                    </v-file-input>
                    </div>
                  </template>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions class="text-center d-block pb-5 btn-size-auto">
              <v-btn color="primary" class="d-inline-block" outlined @click="cancelModalImg">Cancelar</v-btn>
              <v-btn color="primary" class="d-inline-block" :disabled="!file || !file[0]" @click="editImgAstral">Guardar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>

    <v-dialog v-model="dialogDelete" max-width="410px">
      <v-card rounded class="pa-3">
        <v-card-title class="text-center">
          ¿Estas seguro que deseas eliminar la carta astral?
        </v-card-title>

        <v-row class="text-center btn-size-auto">
          <v-col>
            <v-btn class="ma-2" tile color="red darken-2" dark small @click="deleteAstral">Eliminar</v-btn>
            <v-btn class="ma-2" tile outlined color="primary" small @click="dialogDelete = false">Cancelar</v-btn>
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>


    <v-dialog v-model="flagModal" persistent max-width="350">
      <v-card>
        <v-card-title class="headline">Actualizar información</v-card-title>
        <v-card-text>
          Necesitamos que actualize los datos de su perfil para crear su carta astral.
        </v-card-text>
        <v-card-actions>
          <v-btn color="gray" text @click="flagModal = false">Entendido</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="snackbar" :color="colorSnack" :timeout="10000">
      {{ textSnack }}
      <template v-slot:action="{ attrs }">
        <v-btn
            text
            dark
            v-bind="attrs"
            @click="snackbar = false">
          Ok
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>
<script>
import {mapActions, mapState} from "vuex";
import UserSearch from "@/components/UserSearch";

export default {
  name: 'AstralCard',
  components: {UserSearch},
  data() {
    return {
      flagModal: false,
      dialogDelete: false,
      deleteAstralCard: false,
      dialogImg: false,
      arrayObjImg: [],
      imgUrl: '',
      dialogEdit: false,
      dataUpdate: {},
      file: null,
      idAstralCard: '',
      idUser: '',
      dialogAdd: false,
      files: null,
      snackbar: false,
      colorSnack: '',
      textSnack: '',
    }
  },
  computed: {
    ...mapState('astralCard', [
      'data', 'allData']),
    ...mapState('user', [
      'info',
      'currentUser'
    ]),
  },
  methods: {
    ...mapActions(
        'astralCard', [
          'fetchDataAllAstralCard',
          'updateAstralCard',
          'updateData',
          'removeAstralCard',
          'addUserAstralCard',
          'fetchAstralCardUserId'
        ]
    ),
    ...mapActions(
        'user', [
          'fetchInfo',
          'updateCurrentUser'
        ]
    ),
    ...mapActions(['loaderChange']),
    filterDataIdUser() {

      this.loaderChange(true)

      let request = {
        id: this.currentUser
      }
      this.fetchAstralCardUserId(request).finally(() => {
        this.loaderChange(false)
      })

    },
    verifyDataCompleted() {
      this.loaderChange(true)
      this.fetchInfo()
          .then(() => {
            let user = this.info.user_data
            let _isComplete = user.birth_date && user.names && user.surnames && user.born_country && user.born_place ? true : false
            if (_isComplete) {
              this.sendMail()
            } else {
              this.showModalNeedInfo()
            }
          })
          .finally(() => {
            this.loaderChange(false)
          })
    },
    sendMail() {
      console.log('Enviar email')
    },
    showModalNeedInfo() {
      this.flagModal = true
    },
    deleteModal(id) {
      this.dialogDelete = true
      this.idAstralCard = id
    },
    imgModal(id) {
      this.arrayObjImg = this.allData.find(x => x.id === id);
      this.dialogImg = true
      this.imgUrl = this.arrayObjImg.file_url
    },
    cancelModalImg() {
      this.dialogEdit = false
      this.file = null;
    },
    editModal(id) {
      this.arrayObjImg = this.allData.find(x => x.id === id);
      this.dialogEdit = true
      this.idUser = this.arrayObjImg.user_id
      this.idAstralCard = id
    },
    editImgAstral() {
      this.loaderChange(true)
      this.dialogEdit = false
      this.dataUpdate = new FormData();
      this.dataUpdate.append('user_id', this.idUser)
      this.dataUpdate.append('file', this.file[0])
      let request = {
        data: this.dataUpdate,
        id: this.idAstralCard
      }
      this.updateData(request).then((data) => {
        this.dataUpdate.editableFlag = true
        if(data) {
          this.colorSnack = 'success'
          this.textSnack = 'Subiste la imagen con éxito.'
          this.snackbar = true
        } else  {
          this.colorSnack = 'error'
          this.textSnack = 'Ha ocurrido un error, verifique los datos e intentelo nuevamente.'
          this.snackbar = true
        }
        this.filterDataIdUser()
        })
    },
    deleteAstral() {
      this.loaderChange(true)
      this.dialogDelete = false
      this.dataUpdate = new FormData();
      let request = {
        id: this.idAstralCard
      }
      this.removeAstralCard(request).then((data) => {
        if(data) {
          this.colorSnack = 'success'
          this.textSnack = 'Se eliminó la imagen con éxito.'
          this.snackbar = true
        } else  {
          this.colorSnack = 'error'
          this.textSnack = 'Ha ocurrido un error, intentelo nuevamente.'
          this.snackbar = true
        }
        this.filterDataIdUser()
      })
    },
    saveAstral() {
      this.loaderChange(true)
      this.dialogAdd = false
      this.dataUpdate = new FormData();
      this.dataUpdate.append('user_id', this.currentUser)
      this.dataUpdate.append('file', this.files[0])
      let request = {
        data: this.dataUpdate
      }

      this.addUserAstralCard(request).then((data) => {
        if(data) {
          this.colorSnack = 'success'
          this.textSnack = 'Subiste la imagen con éxito.'
          this.snackbar = true
        } else  {
          this.colorSnack = 'error'
          this.textSnack = 'Ha ocurrido un error, verifique los datos e intentelo nuevamente.'
          this.snackbar = true
        }
        this.filterDataIdUser()
      })
    },
    closeSaveAstral() {
      this.dialogAdd = false
      this.files = null;
    }
  },
  mounted() {
    if (location.href.indexOf('?agregarCartaAstral') > -1) {
      this.dialogAdd = true
    }
    this.updateCurrentUser('')
  }
}
</script>
<style lang="scss" scoped>
.title-astral {
  font-family: "Virgula Vulgaris";
}

::v-deep .title-card-add {
  font-family: Avenir!important;
}

* {
  font-family: "Avenir", sans-serif;
  color: #656565;
}

a {
  font-size: 16px;
  color: #2C8886;
}

::v-deep .v-btn {
  text-transform: unset;
  font-family: "Avenir";
  font-weight: 600;
  letter-spacing: normal;
  font-size: 14px;
  height: 40px;
  width: 160px;
  margin-top: 5px;
  border-radius: 7px;
  letter-spacing: 0 !important;
  text-transform: none !important;
}

.container.fill-height.rj .main-description {
  margin-bottom: 12px;
}

.main-description.disclamer {
  position: absolute;
  bottom: 0;
}

.ctn-astral-card {
  max-width: 550px;
  padding: 20px;
}

.disclamer {
  position: absolute;
  bottom: 10px;
  font-weight: 200;
  max-width: 90%;
}
.table-styled {
  color: #656565;
  width: 100%;
  th {
    font-weight: 800;
    font-size: 14px !important;
    &:last-child {
      text-align: center !important;
      width: 20%;
    }
  }
}
  .ctn-astral {
    width: 100%;
  }
  .ctn-file-input {
    margin-top: 15px;
  }
  ::v-deep .v-counter{
    position: absolute;
    left: 0;
    margin-left: 3px !important;
  }
</style>
